export default __webpack_public_path__ + "static/media/IkonLavereOmkostninger.e0cd6eb4.svg";